
import { combineReducers } from "redux";

// reducer
import loginReducer from './login/loginReducer'
import transactionReducer from './transaction/transactionReducer'
import analyticReducer from './analytic'
import notifiesReducer from './notifies'
import deviceReducer from './device'
import merchantReducer from './merchant'
import bankReducer from './bank'
import settingReducer from './setting'
import customerReducer from './customer'
import permissionReducer from './permission'

// types
import { LOGOUT } from "./login/types";

const app = combineReducers({
  loginReducer,
  transactionReducer,
  analyticReducer,
  notifiesReducer,
  deviceReducer,
  merchantReducer,
  bankReducer,
  settingReducer,
  customerReducer,
  permissionReducer
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) state = undefined

  return app(state, action);
};

export default rootReducer;